<template>
  <div class="login container">
    <div v-if="!redeemTicketPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <div v-else>
      <form @submit.prevent="$nextTick(submit)">

          <div class="d-flex justify-content-between">
            <div class="col-xs-6 pl-3 pt-5">
              <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
            </div>


            <div class="col-xs-6  pr-3 pt-5">
              <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!ticket_reference || errors.has('ticket_reference')" margin="no-margin" :loading="submitted" />
            </div>
          </div>


          <div class="row">
          <h2 class="col-md-12 pt-2">Manually key in ticket reference</h2>
          </div>

          <div class="row d-flex justify-content-center">
          <div class="text-input-holder col-sm-12 pt-4 size-limit">
            <text-input :allowModelSet="true"  v-model="ticket_reference" placeholder="Enter ticket reference" name="ticket_reference"  />
          </div>
          </div>

      </form>

        <div class="row">
          <h4 class="col-md-12 mt-5 mb-3">... or scan QR code</h4>
          <div class=" col-md-12 d-flex justify-content-center align-items-center">
            <div :class="`view-finder-wrapper d-flex justify-content-center align-items-center`">
                <div class="loader" v-if="cameraActivated"></div>
                <qrcode-stream v-if="!destroyed" :camera="camera" :class="`view-finder ${cameraActivated ? '':'d-none'}`" @decode="onDecode" @init="onInit"></qrcode-stream>
                <button :class="`activate-camera-button ${cameraActivated ? 'd-none':''}`" @click="toggleCamera">Activate Camera</button>
            </div>

          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
  name: 'Login',
  components: {
     QrcodeStream,
  },
  inject: ['$validator'],
  data : function(){       
      return {
        ticket_reference: '',
        submitted     : false,
        camera:'auto',
        error:'',
        destroyed: false
      };

  },

  computed: {
    
    ticket(){
        return this.$store.getters.getTicket;
    },
    account(){
      return this.$store.getters.getAccount;
    },
    cameraActivated() {
        return this.$store.getters.getCameraActivated;
    }
  },

  methods:{
      /*
      * Decode QR code
      */
      onDecode(decodedString) {
          this.ticket_reference = decodedString;
          
          this.reload()
      },
      async reload () {
        this.destroyed = true

        await this.$nextTick()

        this.destroyed = false
      },
      toggleCamera() {
        this.$store.commit('SET_CAMERA_ACTIVATED',!this.cameraActivated)
      },

      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson"
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device"
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)"
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?"
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable"
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser"
          }
        }
      },

      /*
      * Login form submit handler
      */
      submit() {

          this.ticket_reference = this.ticket_reference.replace(/[^a-zA-Z0-9\s+\-.]/g, ''); 

          this.$validator.validateAll().then((result) => {
            if(result){
              this.submitted = true;

              window.axios({
                url: process.env.VUE_APP_API_GRAPH_URL,
                method: 'post',
                data: {
                  query: `
                    query($limit:Int!,$page:Int!,$ticket_reference:String!,$account_id:Int!){
                        Tickets(ticket_reference:$ticket_reference, limit:$limit, page:$page, account_id:$account_id){
                          data{
                            ticket_reference
                            event_datetime
                            EventSlot{
                              local_time
                            },
                            unit_id,
                            PriceModifier{
                              price,
                              description
                            }
                            Product{
                              name,
                              id,
                              TicketProductConfig{
                                ticket_instructions
                                Units {
                                  id
                                  name
                                }
                              }
                            }
                          }
                          total,
                          per_page
                        },
                    }
                  `,
                  variables: {
                    ticket_reference: this.ticket_reference,
                    page          : 1,
                    limit         : 1,
                    account_id    : this.account.id
                  }
                }
              }).then((result) => {

                if(result.data.data && result.data.data.Tickets.data.length){

                  this.$store.commit('SET_TICKET', result.data.data.Tickets.data[0]);
                  this.$router.push({ name: 'redeem-ticket'});
                }else{
                  this.errors.add({field:'ticket_reference',msg:'Ticket not found'});
                }
              }).catch( () => {
                  this.$bus.$emit('error_message', 'Something went wrong, please try again!');
              }).then(() => {
                  this.submitted = false;
              });
              
            }
          });

      },

  }
}
</script>

<style scoped>
.loader {
  position: absolute;
}
</style>
